<template>
  <div class="content">
    <div class="category-menu">
      <div v-for="item in categoryMenu" :key="item.text">
        <img :src="item.icon" />
        {{ item.text }}
      </div>
    </div>
    <div :visible="true" :modal="false" :show-close="false" class="dialog-drag">
      <el-popover
        placement="top-start"
        trigger="click"
        popper-class="area-popper"
      >
        <div style="width: 310px">
          <category-filter
            ref="categoryFilter"
            :high-light="true"
            @change="fetchPoint"
          />
        </div>
        <div slot="reference" style="width: 35px; height: 35px">
          <i class="el-icon-search" style="font-size: 22px; color: #067df9" />
        </div>
      </el-popover>
    </div>
    <div id="map-container"></div>
    <div
      ref="infoData"
      v-show="isShowInfo"
      class="input-card content-window-card"
    >
      <div class="content-window-card" ref="infoData" v-show="isShowInfo">
        <img
          src="@/assets/newImages/eventx.png"
          style="
            height: 20px;
            width: 45px;
            cursor: pointer;
            position: absolute;
            right: 10px;
            top: 8px;
            z-index: 9;
          "
          @click="closeInfoWindow()"
        />
      </div>
      <div class="info-middle">
        <div style="margin: 15px 0px; position: relative">
          <div class="popup-row">
            <div class="popup-row-label">企业名称：</div>
            <div class="popup-row-value">{{ companyInfo.name }}</div>
          </div>
          <div class="popup-row">
            <div class="popup-row-label">管理类型：</div>
            <div class="popup-row-value">{{ companyInfo.manageCategory }}</div>
          </div>
          <div class="popup-row">
            <div class="popup-row-label">地址：</div>
            <div class="popup-row-value">{{ companyInfo.addr }}</div>
          </div>
          <div
            class="popup-row"
            v-if="companyInfo.manageCategory != '处置单位'"
          >
            <div class="popup-row-label">危废产生量：</div>
            <div class="popup-row-value">{{ companyInfo.dangerWaster }} 吨</div>
          </div>

          <div class="company-detail">
            <span
              style="
                position: absolute;
                right: 10px;
                color: #fff;
                font-weight: bolder;
                cursor: pointer;
              "
              @click="detail()"
              >查看详情 >>></span
            >
          </div>
        </div>
      </div>
      <div
        style="
          margin: 0 auto;
          width: 40px;
          height: 20px;
          bottom: -18px;
          position: relative;
          overflow: hidden;
        "
      >
        <div class="tdt-infowindow-tip"></div>
      </div>
    </div>
    <!-- <div
      ref="infoData"
      v-show="isShowInfo"
      class="custom-info input-card content-window-card"
    >
      <div class="info-top">
        <div>
          <span>{{ companyInfo.name }}</span>
          </div>
        <img
          @click="closeInfoWindow"
          src="https://webapi.amap.com/images/close2.gif"
        />
      </div>
      <div class="info-middle" style="background-color: white">
        <div>
          <span>管理类型：</span>
          <span>{{ companyInfo.manageCategory }}</span>
        </div>
        <div>
          <span>地址：</span>
          <span>{{ companyInfo.addr }}</span>
        </div>

        <div v-if="companyInfo.manageCategory != '处置单位'">
          <span>危废产生量：</span>
          <span>{{ companyInfo.dangerWaster }} 吨</span>
        </div>
        <div class="company-detail">
          <span @click="detail()">查看详情 >>></span>
        </div>
      </div>
      <div
        class="info-bottom"
        style="position: relative; top: 0px; margin: 0px auto"
      >
        <img src="https://webapi.amap.com/images/sharp.png" />
      </div>
    </div> -->
    <companyDetail style="color: #000" ref="companyDetail"></companyDetail>

    <!-- <div class="info">
      点击地图上的点标记，打开所添加的自定义信息窗体
    </div> -->
  </div>
</template>
<script>
import categoryFilter from "./components/categoryFilter";
import companyDetail from "@/components/companyDetail.vue";

import zhongdianIcon from "@/assets/markers/zhongdian.svg";
import dengjiIcon from "@/assets/markers/dengji.svg";
import jianhuaIcon from "@/assets/markers/jianhua.svg";
import chuzhiIcon from "@/assets/markers/chuzhi.svg";
export default {
  data() {
    return {
      isShowInfo: false,
      companyInfo: {},
      categoryMenu: [
        {
          text: "重点监管",
          icon: zhongdianIcon,
        },
        {
          text: "登记管理",
          icon: dengjiIcon,
        },
        {
          text: "简化管理",
          icon: jianhuaIcon,
        },
        {
          text: "处置企业",
          icon: chuzhiIcon,
        },
      ],

      map: null,
      companies: [],
      markers: [],
      geo: null,
    };
  },
  components: {
    categoryFilter,
    companyDetail,
  },
  mounted() {
    // this.getData();
    this.createMap();
  },
  computed: {
    searchParams() {
      let { date, ...params } = this.params;
      if (date && date.length > 0) {
        return { startDate: date[0], endDate: date[1], ...params };
      }
      return { ...params };
    },
  },
  created() {},
  methods: {
    detail() {
      this.$refs.companyDetail.getCompanyInfo(this.companyInfo);
    },
    fetchPoint(params) {
      let { date, ...p } = params;
      let searchParams = {};
      if (date && date.length > 0) {
        searchParams = { startDate: date[0], endDate: date[1], ...p };
      } else {
        searchParams = p;
      }
      let url = this.$api.map.getManageCategoryMapData;
      this.$axios.get(url, searchParams, false).then((res) => {
        if (res.data.code == 0) {
          this.companies = res.data.data.companies;

          // this.map.clearMap()

          this.map.remove(this.markers);
          this.addMarker();
          this.clearGeoJson();
          if (searchParams.jurisdiction) {
            this.addGeoJson(searchParams.jurisdiction, "#bfa");
          }
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    getData() {
      let url = this.$api.map.getManageCategoryMapData;
      this.$axios.get(url, false).then((res) => {
        if (res.data.code == 0) {
          this.companies = res.data.data.companies;

          this.map.clearMap();
          this.addMarker();
        } else {
          this.$message({
            message: "加载数据失败，请重试",
            type: "error",
          });
        }
      });
    },

    //1.创建map对象
    createMap() {
      //1.地图初始化时，在地图上添加marker标记,鼠标点击marker可弹出自定义的信息窗体
      this.map = new AMap.Map("map-container", {
        resizeEnable: true,
        animateEnable: false,
        mapStyle: "amap://styles/darkblue",
        // mapStyle: "amap://styles/d88864bb17a5b8d0267b5e0f899e293c",
        // // showLabel: false,
        // features: ['bg', 'road', 'building'],
        center: [116.29920714, 39.681], //初始地图的中心点坐标
        zoom: 14.6,
      });
      this.addGeoJson("all", "#2e9194", true);

      // this.addGeoJson("二期", "red");
      // this.addGeoJson("三期", "green");
    },
    addGeoJson(jsonName, color, isAll) {
      let geoJSON = require(`@/assets/geojson/${jsonName}.json`);
      // let geoJSON = require(jsonName);

      let geojson = new AMap.GeoJSON({
        geoJSON: geoJSON,
        // 还可以自定义getMarker和getPolyline
        getPolygon: function (geojson, lnglats) {
          // 计算面积
          return new AMap.Polygon({
            path: lnglats,
            fillOpacity: 0.1, // 面积越大透明度越高
            strokeColor: color,
            fillColor: color,
          });
        },
      });
      if (!isAll) this.geo = geojson;

      this.map.add(geojson);
    },
    clearGeoJson() {
      if (this.geo) this.map.remove(this.geo);
    },

    //2.添加点标记
    addMarker() {
      const self = this;
      let arr = [];
      this.isShowInfo = false;
      this.map.remove(this.markers);
      this.markers = [];

      this.companies.forEach((item) => {
        let iconImg = null;
        switch (item.manageCategory) {
          case "重点监管":
            iconImg = zhongdianIcon;
            break;
          case "简化管理":
            iconImg = jianhuaIcon;
            break;
          case "登记管理":
            iconImg = dengjiIcon;
            break;
          case "处置单位":
            iconImg = chuzhiIcon;
            break;
        }
        const icon = new AMap.Icon({
          // content: "重点",
          // size: new AMap.Size(33, 35), // 图标尺寸
          image: iconImg, //require('@/assets/markers/zhongdian.svg'), // Icon的图像
          // imageOffset: new AMap.Pixel(0, -60), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 35), // 根据所设置的大小拉伸或压缩图片
        });

        const position = [item.lng, item.lat];

        let marker = new AMap.Marker({
          icon, //点标记图片路径
          position, //位置
          anchor: "bottom-center",
        });
        arr.push(
          Object.assign(item, {
            mapId: marker._amap_id,
          })
        );
        marker.setMap(self.map);
        marker.on("click", (e) => {
          self.markerClick(arr, marker);
        });
        this.markers.push(marker);

        // AMap.event.addListener(marker, 'click', (e) => {
        //   self.markerClick(arr, marker)
        // })
      });

      // 创建AMap.MarkerClusterer的实例
      // const markerClusterer = new AMap.MarkerClusterer(this.map, positions);
    },
    //3.点击标记 获取所点击标记的信息以及窗体要展示的数据，创建信息窗体
    markerClick(arr, marker) {
      let arrNew = arr.filter((x) => x.mapId == marker._amap_id);
      this.companyInfo = arrNew && arrNew[0];
      let infoWindow = this.createInfoWindow();
      this.openInfoWindow(infoWindow, marker);
    },
    //4.构建自定义窗体
    createInfoWindow() {
      let infoWindowData = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗体
        content: this.$refs.infoData,
        // content: this.getContent(),
        anchor: "bottom-center",
        offset: new AMap.Pixel(16, -50),
      });
      return infoWindowData;
    },

    //5.打开窗体
    openInfoWindow(infoWindow, marker) {
      this.isShowInfo = true;
      this.$nextTick(() => {
        infoWindow.open(this.map, marker.getPosition());
      });
    },
    //6.关闭窗体
    closeInfoWindow() {
      this.isShowInfo = false;
      this.map.clearInfoWindow();
    },
  },
};
</script>

<style lang="scss" scoped>
html,
body,
#map-container {
  height: 100%;
  width: 100%;
}

.content {
  position: relative;
  height: 100%;
  width: 100%;
}

.category-menu {
  display: flex;
  position: absolute;
  top: 20px;
  left: 10px;
  z-index: 1;
  color: #fff;

  > div {
    margin-right: 20px;
  }
}

.dialog-drag {
  position: absolute;
  top: 20px;
  right: 25px;
  z-index: 99;
  width: 240px;
  width: 35px;
  //height: 400px;
  //background-color: #ffffff;
  //padding: 15px;
  //border: 1px solid #e3e3e8;
  border-radius: 4px;
}

.content-window-card {
  position: relative;
  box-shadow: none;
  bottom: 0;
  left: 0;
  /* width: auto; */
  width: 350px;
  padding: 0;
}

.content-window-card p {
  height: 2rem;
}

.custom-info {
  // border: solid 1px silver;
}

.popup-row {
  width: 350px;
  // width: 100%;
  padding: 4px 10px;
  font-size: 13px;
  display: flex;
  &::after {
    clear: both;
    content: "";
    display: block;
  }

  .popup-row-label {
    width: 90px;
    // display: inline-block;
    color: #7dc3f6;
    text-align: right;
    font-size: 14px;
  }

  .popup-row-value {
    flex: 1;
    // width: 200px;
    // overflow: hidden;
    // text-overflow: ellipsis;
    // white-space: nowrap;
    // display: block;
    // margin-left: 100px;
    color: #d7d7d7;
    font-size: 14px;
  }
}
/deep/ .amap-info {
  background: url("../../assets/newImages/infoWindow.png") no-repeat 100% 100%;
  background-size: 100% 100%;
  // color: #024287;
}
/deep/ .tdt-container a.tdt-infowindow-close-button {
  color: transparent;
  background: url("../../assets/newImages/eventx.png") no-repeat;
  background-size: 100% 100%;
  width: 40px;
  height: 20px;
}
/deep/ .tdt-infowindow-tip {
  width: 17px;
  height: 17px;
  padding: 1px;
  margin: -10px auto 0;
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
  background: #094a92;
}

div.info-top {
  position: relative;
  // color:#2e9194
  background: none repeat scroll 0 0 #f9f9f9;
  border-bottom: 1px solid #ccc;
  border-radius: 5px 5px 0 0;
}

div.info-top div {
  display: inline-block;
  color: #333333;
  font-size: 14px;
  font-weight: bold;
  line-height: 31px;
  padding: 0 10px;
}

div.info-top img {
  position: absolute;
  top: 10px;
  right: 10px;
  transition-duration: 0.25s;
}

div.info-top img:hover {
  box-shadow: 0px 0px 5px #000;
}

div.info-middle {
  font-size: 12px;
  padding: 10px 6px;
  line-height: 20px;
  position: relative;
}

div.info-bottom {
  height: 0px;
  width: 100%;
  clear: both;
  text-align: center;
}

div.info-bottom img {
  position: relative;
  z-index: 104;
}

/* span {
  margin-left: 5px;
  font-size: 11px;
} */

.info-middle img {
  float: left;
  margin-right: 6px;
}

.info-span {
  /* margin-left: 35px; */
  font-size: 11px;
}

.info-div {
  width: 140px;
  display: inline-block;
  margin-left: 10px;
}

.info-img {
  width: 40px;
  height: 40px;
}

.info-a-title {
  /* color: #000000; */
  font-size: 16px;
}

#map-container {
  height: 100%; //820px;
}

#map-container .amap-icon img,
.amap-marker-content img {
  width: 64px;
  height: 64px;
}
</style>